import React from 'react';
import { motion } from 'framer-motion';

const FinalCTASection = () => {
  const handleCTAClick = () => {
    window.open('https://abdul.cc/awaaipay', '_blank');
  };

  return (
    <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-black bg-opacity-50">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            🎯 Take Action Before Time Runs Out!
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 mb-8">
            Don't wait... this deal won't come back again.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <button
            onClick={handleCTAClick}
            className="bg-green-500 hover:bg-green-400 text-black text-2xl sm:text-3xl font-bold py-6 sm:py-8 px-12 sm:px-16 rounded-full shadow-2xl transform transition-all duration-300 mb-8 animate-pulse"
          >
            Claim My Spot Now 🚀
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="space-y-4"
        >
          <p className="text-red-400 text-xl sm:text-2xl font-bold">
            Offer Ends 30th Sept 2025 @ 10PM IST | Only 15 Spots!
          </p>
          
          <div className="text-yellow-400 text-lg sm:text-xl space-y-2">
            <p>✅ Pay ₹4,997 for 1 Month → Get 12 Months FREE!</p>
            <p>✅ Sleep peacefully knowing leads, sales & payments run on autopilot</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;